@use "../../styles/variables" as vars;

.field {
  display: grid;
  gap: 0;

  input,
  textarea {
    width: 100%;
    min-height: 34px;
    padding: 5px 0;
    border: 0;
    border-bottom: 1px solid vars.$color-muted;
    border-radius: 0;
    background: transparent;
    color: vars.$color-text;
    font-family: vars.$font-medium;
    font-size: 16px;
    transition: border-color 0.3s ease, color 0.3s ease;

    &:focus {
      border-color: vars.$color-secondary;
      box-shadow: none;
      outline: none;
    }

    &[aria-invalid="true"] {
      border-color: vars.$color-error;
    }
  }

  textarea {
    min-height: 52px;
    padding: 5px 0;
    resize: none;
  }

  input::placeholder,
  textarea::placeholder {
    color: vars.$color-muted;
    opacity: 1;
  }
}

.description {
  display: flex;
  min-height: 15px;
  align-items: flex-start;
  gap: 2px;
  padding-top: 2px;
  font-family: vars.$font-medium;
}

.asterisk {
  color: vars.$color-primary;
  font-size: 16px;
  line-height: 1;
}

.error {
  color: vars.$color-error;
  font-size: 13px;
  font-family: vars.$font-medium;
}

.hint {
  color: vars.$color-muted;
  font-size: 13px;
}

.invalid input,
.invalid textarea {
  border-bottom: 2px solid vars.$color-primary;
  color: vars.$color-primary;
  animation: shake 0.3s ease-in-out;
}

.valid input,
.valid textarea {
  border-bottom: 2px solid vars.$color-success;
  color: vars.$color-success;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
}

@media (min-width: 1081px) and (max-height: 1250px) {
  .field {
    input,
    textarea {
      min-height: 30px;
      padding-top: 3px;
      padding-bottom: 3px;
    }

    textarea {
      min-height: 42px;
    }
  }

  .description {
    min-height: 12px;
    padding-top: 1px;
  }
}

@media (min-width: 1081px) {
  .field {
    input,
    textarea {
      min-height: 30px;
      font-size: 13px;
    }
  }

  .asterisk {
    font-size: 13px;
  }

  .error,
  .hint {
    font-size: 11px;
  }
}

@media (max-width: 600px) {
  .field {
    input,
    textarea {
      min-height: 32px;
      font-size: 14px;
    }
  }

  .asterisk {
    font-size: 14px;
  }

  .error,
  .hint {
    font-size: 11px;
  }
}
